import { useQuery } from 'react-query';

import { useCreateTicketState } from '@store/hookstate';

import { getEquipment } from '@services/queries/equipments';

import ProductImage from '@assets/png/product.png';
import ProfileImage from '@assets/png/profile.png';

import { getProductValue } from '@utils/getProductValue';
import { EquipmentBarError } from './error/EquipmentBar.error';
import { EquipmentBarLoading } from './loading/EquipmentBar.loading';

import {
  Container,
  Image,
  Left,
  Right,
  Text,
  UserImage,
} from './EquipmentBar.styles';

const EquipmentBar = () => {
  const createTicketState = useCreateTicketState();

  const { data, isLoading, isError } = useQuery(
    ['tickets', createTicketState.equipmentId.get()],
    () => getEquipment(createTicketState.equipmentId.get()),
  );

  if (isLoading) {
    return <EquipmentBarLoading />;
  }

  if (isError || !data) {
    return <EquipmentBarError />;
  }
  const { name, model, manufacturerName } = getProductValue(data);

  return (
    <Container>
      <Left>
        <Image className="defaultImage" src={ProductImage} alt="product" />
        <div style={{ width: 8 }} />
        <Text>{name}</Text>
      </Left>
      <Text>{data.serial}</Text>
      <Text>{manufacturerName || ''}</Text>
      <Text>{model}</Text>
      <Right>
        <UserImage src={ProfileImage} alt="user" />
        <div style={{ width: 8 }} />
        <Text>{name}</Text>
      </Right>
    </Container>
  );
};

export { EquipmentBar };
